import dayjs from 'dayjs';
import 'dayjs/locale/de-ch';

dayjs.locale('de-ch');

export const dateFormat = 'DD.MM.YYYY';

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  const d = dayjs(value);
  return d.isValid() ? d.format(dateFormat) : '—';
}

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const d = dayjs(value);
  return d.isValid() ? d.format(`${dateFormat} HH:mm`) : '—';
}

export function formatInitials(firstName: string, lastName: string): string {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}
